export const environment = {
  production: 0,
  apiUrl: 'https://api-dev.pestforceapp.com',
  documentStorageUrl: 'https://pestware-storage-devs.s3.amazonaws.com/',
};
